<div class="row m-0">
  <div class="col-md-12 formborder">
    <div class="col-md-4 float-right">
      <button
        class="mt-3 btn font-size-12 button-btn float-right"
        (click)="exportexcelNew()"
      >
        <i
          class="fa fa-file-export mr-1"
          style="font-size: medium; cursor: pointer"
        ></i>
        Export
      </button>
    </div>
  </div>

  <div class="col-md-12 p-1">
    <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
    <div class="table-responsive mt-1">
      <mat-table
        [dataSource]="dataSource"
        matSort
        style="overflow: auto; max-width: 100%; height: 60vh"
      >
        <ng-container matColumnDef="StateId">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            style="max-width: 3.125rem"
            *matHeaderCellDef
          >
            #
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row; let i = index"
            class="grid-cell"
            style="max-width: 3.125rem"
          >
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="State_Name">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            style="max-width: 15.625rem"
            *matHeaderCellDef
          >
            State
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            class="grid-cell"
            style="max-width: 15.625rem"
          >
            {{ row.State_Name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Code">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            Code
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Code }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="StateCode">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            State Code
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.StateCode }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="GSTCode">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            GST Code
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.GSTCode }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Region_Count">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            Region Count
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Region_Count }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Action">
          <mat-header-cell
            class="grid-header j-c-center"
            *matHeaderCellDef
          >
            Action
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell j-c-center">
            <i
              class="fas fa-lg fa-edit margin-right-4xs cursor-style"
              aria-label="true"
              (click)="onEditState(row)"
            ></i>
          </mat-cell>
        </ng-container>
        <!-- Header and Row Declarations -->
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <mat-paginator
        #paginatorRef
        [pageSizeOptions]="[20, 50]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>

<div class="modal fade in" id="EditStateModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
<div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 500px;">
  <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
    <div cdkDragHandle class="modal-header" style="padding: 8px 12px;">
      <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
       Edit State
      </h6>
      <button type="button" (click)="onCloseModal()" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
      </button>
    </div>
    <div class="modal-body" style="padding: 12px;">
      <form #f="ngForm">
        <div class="row m-0">
          <div class="col-md-6 p-1">
            <span class="required-lable">State</span>
            <input
              type="text"
              name="State_Name"
              [(ngModel)]="editStateObj.State_Name"
              class="form-control input-text-css"
              readonly
            />
          </div>
          <div class="col-md-6 p-1">
            <span class="required-lable">Code</span>
            <input
              type="text"
              name="Code"
              [(ngModel)]="editStateObj.Code"
              class="form-control input-text-css"
              readonly
            />
          </div>
          <div class="col-md-6 p-1">
            <span class="required-lable">Statecode</span>
            <input
              type="text"
              name="StateCode"
              [(ngModel)]="editStateObj.StateCode"
              class="form-control input-text-css"
              readonly
            />
          </div>
          <div class="col-md-6 p-1">
            <span class="required-lable">Gstcode</span>
            <input
              type="text"
              name="GSTCode"
              [(ngModel)]="editStateObj.GSTCode"
              class="form-control input-text-css"
              readonly
            />
          </div>
          <div class="col-md-12 p-1">
            <span class="required-lable">Zone</span>
            <select
              name="ZoneId"
              [(ngModel)]="selectedZoneId"
              class="form-control input-text-css"
            >
              <option value="">-- Select Zone --</option>
              <option
                *ngFor="let zone of ZoneListDropdown"
                [value]="zone.ZoneId"
              >
                {{ zone.Zone_Name }}
              </option>
            </select>
          </div>
          <div class="col-md-12 text-center mt-2 mb-1">
            <button
              type="button"
              (click)="onSaveState()"
              class="btn font-size-12 button-btn"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
</div>

<table
  id="State_List"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      State
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Code
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      State Code
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      GST Code
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Region Count
    </th>
  </tr>

  <tr *ngFor="let x of JsonData; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.State_Name }}</td>
    <td>{{ x.Code }}</td>
    <td>{{ x.StateCode }}</td>
    <td>{{ x.GSTCode }}</td>
    <td>{{ x.Region_Count }}</td>
  </tr>
</table>
